import React, { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import supabase from '../supabase/supabase';
import ArtistPage from './ArtistPage';
import LabelPage from './LabelPage';
import LoadingScreen from '../components/common/LoadingScreen';
import ErrorState from '../components/common/ErrorState';

/* Routes that must never be treated as profile slugs */
const RESERVED = new Set([
  'admin','label-admin','auth','dashboard','analytics','calendar',
  'discover','vault','profile','drop','releases','404',
]);

const ProfileRouter = () => {
  const { slug } = useParams();
  const [type,    setType]    = useState(null);
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  useEffect(() => {
    if (!slug) { setError('No profile slug provided'); setLoading(false); return; }

    /* Guard reserved words — redirect home instead of querying DB */
    if (RESERVED.has(slug.toLowerCase())) {
      setError('reserved');
      setLoading(false);
      return;
    }

    const resolve = async () => {
      setLoading(true);
      setError(null);
      try {
        const { data: artist } = await supabase
          .from('d2f_artists')
          .select('*')
          .eq('slug', slug)
          .maybeSingle();

        if (artist) { setType('artist'); setData(artist); return; }

        const { data: label } = await supabase
          .from('d2f_labels')
          .select('*')
          .eq('slug', slug)
          .maybeSingle();

        if (label) { setType('label'); setData(label); return; }

        setError('not_found');
      } catch {
        setError('error');
      } finally {
        setLoading(false);
      }
    };

    resolve();
  }, [slug]);

  if (loading)              return <LoadingScreen message="Loading profile…" />;
  if (error === 'reserved') return <Navigate to="/" replace />;
  if (error === 'not_found') return <ErrorState message="Profile not found" />;
  if (error)                return <ErrorState message="Failed to load profile" />;
  if (type === 'artist')    return <ArtistPage artist={data} />;
  if (type === 'label')     return <LabelPage label={data} />;
  return <ErrorState message="Unknown profile type" />;
};

export default ProfileRouter;